<template>
  <div id="public-statistik" data-app>
    <div class="row">
      <div class="col-12 col-lg-8">
        <div class="row">
          <div class="col-12 col-sm-6">
            <Populasi tipe="GPS"></Populasi>
          </div>
          <div class="col-12 col-sm-6">
            <Populasi tipe="PS"></Populasi>
          </div>
          <div class="col-12 col-sm-6">
            <PopulasiProduksi tipe="GPS"></PopulasiProduksi>
          </div>
          <div class="col-12 col-sm-6">
            <PopulasiProduksi tipe="PS"></PopulasiProduksi>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="row h-100">
          <div class="col-12">
            <SettingHe tipe="GPS"></SettingHe>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <SettingHe tipe="PS"></SettingHe>
      </div>
      <div class="col-12 col-md-4">
        <Produksi tipe="GPS"></Produksi>
      </div>
      <div class="col-12 col-md-4">
        <Produksi tipe="PS"></Produksi>
      </div>
      <div class="col-12 col-md-6">
        <DistribusiPerbulan tipe="GPS"></DistribusiPerbulan>
      </div>
      <div class="col-12 col-md-6">
        <DistribusiPerbulan tipe="PS"></DistribusiPerbulan>
      </div>
      <div class="col-12">
        <DistribusiPerprovinsi></DistribusiPerprovinsi>
      </div>
    </div>

  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import Populasi from "@/view/pages/statistik/_public/_utama/_Populasi.vue"
import PopulasiProduksi from "@/view/pages/statistik/_public/_utama/_PopulasiProduksi.vue"
import SettingHe from "@/view/pages/statistik/_public/_utama/_SettingHe.vue"
import Produksi from "@/view/pages/statistik/_public/_utama/_Produksi.vue"
import DistribusiPerbulan from "@/view/pages/statistik/_public/_utama/_DistribusiPerbulan.vue"
import DistribusiPerprovinsi from "@/view/pages/statistik/_public/_utama/_DistribusiPerprovinsi.vue"
// import DistribusiIntEks from "@/view/pages/statistik/_public/_utama/_DistribusiIntEks.vue"

export default {
  name: "public-statistik",
  components: {
    Populasi,
    PopulasiProduksi,
    SettingHe,
    Produksi,
    DistribusiPerbulan,
    DistribusiPerprovinsi,
    // DistribusiIntEks,
  },
  data() {
    return {
      //
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Poultrynesia" }]);
  },
};
</script>